const AUTO_MSG_SETTINGS = {
  AUTO_MSG_HEADER_RETURN_BTN: 'Return',
  AUTO_MSG_HEADER_TITLE_INPUT_PLACEHOLDER: 'Enter title',

  AUTO_MSG_LIST_EMPTY: 'There is No messages to display',
  AUTO_MSG_NEW_BTN: 'New message',
  AUTO_MSG_GUIDE_LINK: 'Auto message guide',
  AUTO_MSG_COUNT_LABEL: 'messages',
  AUTO_MSG_TABLE_TITLE_1: 'Title',
  AUTO_MSG_TABLE_TITLE_2: 'Status',
  AUTO_MSG_TABLE_TITLE_3: 'Sender',
  AUTO_MSG_TABLE_TITLE_4: 'Last update',
  AUTO_MSG_TABLE_TITLE_5: 'Update by',
  AUTO_MSG_TABLE_TITLE_6: 'Edit and delete',
  AUTO_MSG_CREATE_BLOCK_TOOLTIP:
    'To add new auto message please upgrade your package',
  AUTO_MSG_STATUS_ACTIVE: 'Enabled',
  AUTO_MSG_STATUS_INACTIVE: 'Disabled',
  AUTO_MSG_DELETE_CONFIRM_MSG: 'Are you sure you want to delete this message?',
  DELETE_CONFIRM_MODAL_CONFIRM: 'Submit',
  AUTO_MSG_UNKNOWN_LABEL: 'Unknown',
  AUTO_MSG_FORM_CONTENT_TAB: 'Content',
  AUTO_MSG_FORM_CONDITION_TAB: 'Condition',
  AUTO_MSG_FORM_PUBLISH_TAB: 'Publication date',
  AUTO_MSG_SEND_TYPE_COMPLETE: 'Full message',
  AUTO_MSG_SEND_TYPE_COMPLETE_DESC: 'The message is displayed in full',
  AUTO_MSG_SEND_TYPE_SHORT: 'Short message',
  AUTO_MSG_SEND_TYPE_SHORT_DESC: 'A summary of the message text is displayed',
  AUTO_MSG_SEND_TYPE_NOTIF: 'Notification',
  AUTO_MSG_SEND_TYPE_NOTIF_DESC:
    'Display the small circle at the top of the widget',
  AUTO_MSG_ACTION_SECTION_LABEL: 'Do this action',
  AUTO_MSG_SPIN_ACTION: 'Widget spin',
  AUTO_MSG_OPEN_WIDGET_ACTION: 'Opens widget',
  AUTO_MSG_CLOSE_WIDGET_ACTION: 'Closes widget',
  AUTO_MSG_SHORT_MSG_ACTION: "Sends message won't open widget",
  AUTO_MSG_OPEN_SEND_ACTION: 'Opens widget and sends message',
  AUTO_MSG_SWITCH_JUST_ONCE: 'Submit once per visitor',
  AUTO_MSG_SWITCH_MUTE: 'Send with sound',
  AUTO_MSG_SWITCH_MOBILE: 'can also be sent on mobile',
  AUTO_MSG_SEND_TYPE_TITLE: 'Send as',
  AUTO_MSG_SEND_FROM: 'Send a message from',
  AUTO_MSG_CONDITION_TITLE: 'Under what conditions should it be sent',
  AUTO_MSG_CONDITION_NUM_ALL: 'All conditions occur',
  AUTO_MSG_CONDITION_NUM_LEAST_ONE:
    'At least one of the following conditions occurs',

  AUTO_MSG_CONDITION_TYPE_TIME: 'Time on the page',
  AUTO_MSG_CONDITION_TYPE_TITLE: 'Page Title',
  AUTO_MSG_CONDITION_TYPE_ADDRESS: 'Page Address',

  AUTO_MSG_CONDITION_EQUAL: 'Equal to',
  AUTO_MSG_CONDITION_NOT_EQUAL: 'Not equal to',
  AUTO_MSG_CONDITION_START: 'Starts with',
  AUTO_MSG_CONDITION_END: 'Ends with',
  AUTO_MSG_CONDITION_INCLUDE: 'Includes',
  AUTO_MSG_CONDITION_NOT_INCLUE: 'Not includes',
  AUTO_MSG_MAX_CONDITION_REACHED: 'For more conditions upgrade your package',
  AUTO_MSG_CONDITION_SELECT_TITLE: 'Choose condition',
  AUTO_MSG_TITLE_INPUT_PLACEHOLDER: 'Title',
  AUTO_MSG_ADDRESS_INPUT_PLACEHOLDER: 'https://example.com',
  AUTO_MSG_TIME_INPUT_PLACEHOLDER: 'Seconds',

  AUTO_MSG_PUBLISH_START_TITLE: 'Start sending',
  AUTO_MSG_PUBLISH_START_CUSTOM: 'Set a specific time',
  AUTO_MSG_PUBLISH_END_TITLE: 'End of sending',
  AUTO_MSG_PUBLISH_END_NEVER: 'Never',
  AUTO_MSG_PUBLISH_END_CUSTOM: 'Set a specific time',
  AUTO_MSG_PUBLISH_WHEN_TITLE:
    'Setting the day and hours when this chat can be sent',
  AUTO_MSG_PUBLISH_WHEN_ANYTIME: 'Every day every hour',
  AUTO_MSG_PUBLISH_WHEN_OFFICE: 'During business hours',
  AUTO_MSG_PUBLISH_WHEN_NON_OFFICE: 'During non-working hours',

  //Preview
  AUTO_MSG_PREVIEW_CONTENT_TITLE: 'Content',
  AUTO_MSG_PREVIEW_CONDITION_TITLE: 'Condition',
  AUTO_MSG_PREVIEW_PUBLISH_TITLE: 'Publication date',
  AUTO_MSG_PREVIEW_CONTENT_BADGE_COMPLETE: 'Full message',
  AUTO_MSG_PREVIEW_CONTENT_BADGE_NOTIF: 'Notif',
  AUTO_MSG_PREVIEW_CONTENT_BADGE_SHORT: 'Short message',
  AUTO_MSG_PREVIEW_BADGE_UNDEFINED: 'undefined',

  AUTO_MSG_MESSAGE_TITLE: 'Message text',
  AUTO_MSG_OPERATOR_SELECT_RANDOM: 'Random selection',

  AUTO_MSG_PREVIEW_TIME_CONDITION: 'Time on the page',
  AUTO_MSG_PREVIEW_ADDRESS_CONDITION: 'Page address equal to',
  AUTO_MSG_PREVIEW_TITLE_CONDITION: 'Page title equal to',
  AUTO_MSG_PREVIEW_SECONDS: 'Seconds',

  AUTO_MSG_PREVIEW_PUBLISH_NOW: 'Now',
  AUTO_MSG_PREVIEW_PUBLISH_NEVER: 'Never',
  AUTO_MSG_PREVIEW_PUBLISH_ANYTIME: 'Every day every hour',
  AUTO_MSG_PREVIEW_PUBLISH_NON_OFFICE: 'During non-working hours',
  AUTO_MSG_PREVIEW_PUBLISH_OFFICE: 'During business hours',
  AUTO_MSG_PREVIEW_PUBLISH_CUSTOM: 'Specific time',

  AUTO_MSG_PREVIEW_START_PUBLISH: 'Start sending',
  AUTO_MSG_PREVIEW_END_PUBLISH: 'End of sending',

  AUTO_MSG_EDITOR_REMAINING_CHAR: 'Remaining characters',
  AUTO_MSG_EDITOR_PLACEHOLDER: 'Auto message',

  AUTO_MSG_SAVEBAR_SUBMIT: 'Publish',
  AUTO_MSG_SAVEBAR_EDIT: 'Edit',
};

export default AUTO_MSG_SETTINGS;
